import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import { FormattedMessage } from 'react-intl';

import { CloseButton, IconButton, IconsGroup, NudgeText, NudgeWrapper } from './Styles';
import { ENudgeAction, TFeedbackNudgeProps, TNudgeActionConfig } from './types';

const NUDGE_ACTIONS: Record<ENudgeAction, TNudgeActionConfig> = {
  [ENudgeAction.LIKE]: {
    icon: 'rioglyph rioglyph-thumbs-up',
    tooltipId: 'chatPage.feedbackNudge.tooltip.like',
    ariaLabel: 'like',
    testId: 'feedback-nudge-like',
  },
  [ENudgeAction.DISLIKE]: {
    icon: 'rioglyph rioglyph-thumbs-down',
    tooltipId: 'chatPage.feedbackNudge.tooltip.dislike',
    ariaLabel: 'dislike',
    testId: 'feedback-nudge-dislike',
  },
  [ENudgeAction.COMMENT]: {
    icon: 'rioglyph rioglyph-comment',
    tooltipId: 'chatPage.feedbackNudge.tooltip.comment',
    ariaLabel: 'comment',
    testId: 'feedback-nudge-comment',
  },
};

const FeedbackNudge = ({ onAction, onClose }: TFeedbackNudgeProps) => {
  return (
    <NudgeWrapper id="popover-positioned-bottom-end" data-testid="feedback-nudge">
      <NudgeText>
        <FormattedMessage id="chatPage.feedbackNudge.title" />
      </NudgeText>
      <IconsGroup>
        {Object.entries(NUDGE_ACTIONS).map(([action, config]) => (
          <OverlayTrigger
            key={config.testId}
            placement="top"
            overlay={
              <Tooltip>
                <FormattedMessage id={config.tooltipId} />
              </Tooltip>
            }
          >
            <IconButton
              onClick={() => onAction(action as ENudgeAction)}
              aria-label={config.ariaLabel}
              data-testid={config.testId}
            >
              <span className={config.icon} />
            </IconButton>
          </OverlayTrigger>
        ))}
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip>
              <FormattedMessage id="chatPage.feedbackNudge.tooltip.close" />
            </Tooltip>
          }
        >
          <CloseButton onClick={onClose} aria-label="close" data-testid="feedback-nudge-close">
            <span className="rioglyph rioglyph-remove" />
          </CloseButton>
        </OverlayTrigger>
      </IconsGroup>
    </NudgeWrapper>
  );
};

export default FeedbackNudge;
